<script setup lang="ts">
import {computed} from "vue";
import SendcryptLogo from "@/components/SendcryptLogo.vue";

interface Props {
  modelValue: boolean
}

const props = defineProps<Props>()
const emit = defineEmits(['update:modelValue'])
const value = computed({
    get() {
        return props.modelValue
    },
    set(value) {
        emit('update:modelValue', value)
    }
})
</script>

<template>
    <v-list-item
        height="36"
    >
        <template #prepend>
            <v-avatar size="48">
                <sendcrypt-logo width="36" />
            </v-avatar>
        </template>
        <template #append>
            <v-btn
                variant="text"
                icon="mdi-close"
                size="small"
                rounded="lg"
                @click="value = false"
            />
        </template>
    </v-list-item>
</template>

<style scoped>

</style>
